export default {"src":"/_next/static/media/GastrointestinalBleeding.79925e2f.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};